import { useState, useCallback, useEffect, useRef } from "react";
import styles from "./UpgradeUser.module.css";
import { themeColors } from "../../Components/theme";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import useRazorpay from "react-razorpay";
import axios from "axios";
import { firestore } from "../../Firebase";
import { url } from "../../Values/constants";
import SuccessAndFailureModal from "../../Components/SuccessAndFailureModal/SuccessAndFailureModal";
import moment from "moment";
import { getDateIsoString, compareDates, addMonthsWithoutTimestamp, getFormattedDate } from "../../Values/utils";
import { numberWithCommas } from "../../Services/booking";
import { fetchLicensesCost } from "../../Services/resources";
import { fetchCouponList } from "../../Services/contacts";
import "../../theme-vars.css";
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import StyledCancelButton from "../../Components/Buttons/StyledCancelButton";
import { useMediaQuery } from "@mui/material";
import Select from "react-select";
import InputTextValue from "../../Components/TextInput/InputTextValue";

const UpgradeUser = ({ theme, user, organizationData, authToken }: any) => {
  const isMobile = useMediaQuery('(max-width: 900px)');
  const [units, setUnits] = useState<any>(1);
  const [noEmp, setNoEmp] = useState<any>("");
  const [unitsValidation, setUnitsValidation] = useState<any>(false);
  const [costLicensesData, setCostLicensesData] = useState<any[] | undefined>(undefined);
  const [openModal, setOpenModal] = useState(false);
  const [isTransactionSuccess, setIsTransactionSuccess] = useState(false);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [couponMessage, setCouponMessage] = useState("");
  const [couponError, setCouponError] = useState("");
  const [filterData, setFilterData] = useState<any[]>([]);
  const [selectedCoupon, setSelectedCoupon] = useState("");
  const [amountTotal, setAmountTotal] = useState(0);
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [maxHeight, setMaxHeight] = useState(window.innerHeight * 0.9);
  let costPerLicense = organizationData && organizationData.cost_per_license;
  let validTillTimestamp = organizationData && organizationData.valid_till;
  let validTill = getDateIsoString(validTillTimestamp);
  let currentDate = new Date().toISOString().slice(0, 10);
  let isValidTillDatePassed = compareDates(currentDate, validTill);
  let start = moment(currentDate);
  let end = moment(validTill);
  let daysDifference = end.diff(start, "days") + 1;
  let orgName = organizationData && organizationData.organization_name;
  let mailId = organizationData && organizationData.org_mail_id && organizationData.org_mail_id[0];
  let address = organizationData && organizationData.address;
  let contactNumber = organizationData && organizationData.mobile_number;
  let perDayLicenseCost = Math.round(costPerLicense / 30);
  let amount: any = Math.round(perDayLicenseCost * units * daysDifference);
  let tax: any = Math.round(((18 / 100) * amount));
  let totalAmount = Number(amount) + Number(tax);
  let adminMailId = organizationData && organizationData.admin_email_id;
  let isIGST = organizationData && organizationData.is_IGST;

  const handleResize = () => {
    setMaxHeight(window.innerHeight * 0.9);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    fetchLicensesCost((data) => setCostLicensesData(data));
  }, [])

  useEffect(() => {
    const EmployessNo = costLicensesData?.[0]?.no_employees;
    const no_of_employees = organizationData?.org_trial_period_users_licenses
    // const no_of_employees = organizationData.no_of_employees;
    const subNoEmployees = parseInt(EmployessNo) - parseInt(no_of_employees);
    // console.log("organizationData",organizationData?.org_trial_period_users_licenses);
    setNoEmp(subNoEmployees);
  }, [costLicensesData]);

  useEffect(() => {
    const unsub = fetchCouponList("QzA8Wu90bmJkLc6eYMHd", (data) =>
      setFilterData(data)
    );
    return () => {
      unsub();
    };
  }, []);

  const handleApplyCoupon = () => {
    setCouponMessage("");
    setCouponError("");
    setAmountTotal(0);
    setDiscountAmount(0);
    setIsCouponApplied(false);
    // 1. Validate selected coupon
    const coupon = filterData.find((c) => String(c.name) === String(selectedCoupon));

    if (!coupon) {
      setCouponError("❌ Invalid coupon code.");
      setIsCouponApplied(false);
      return;
    }

    // 2. Apply discount if valid
    const actualAmount = Number(amount) + Number(tax);
    const discount = (actualAmount * Number(coupon.value)) / 100;
    const discountedTotal = actualAmount - discount;

    setAmountTotal(discountedTotal);
    setDiscountAmount(discount);
    setIsCouponApplied(true);

    // 3. Success message
    setCouponMessage(`🎉 Congratulations! Coupon "${coupon.name}" applied successfully.`);
  };

  const handleClearCoupon = () => {
    setAmountTotal(0);
    setDiscountAmount(0);
    setIsCouponApplied(false);
    setCouponMessage("");
    setCouponError("");
    setSelectedCoupon("");
  }

  const updatePlan = (organizationId: any) => {
    // let totalUsers = localStorage.getItem('totalUsers') ? Number(localStorage.getItem('totalUsers')) : units;
    let docRef = firestore.collection("organizations").doc(organizationId);
    docRef.update({
      no_of_employees: Number(organizationData.no_of_employees) + units
    })
      .then(() => {
        setOpenModal(true);
        setIsTransactionSuccess(true);
      })
      .catch((error) => {
        setOpenModal(true);
        setIsTransactionSuccess(false);
      });
  }
  const Razorpay = useRazorpay();

  const handlePayment = useCallback(async (totalAmount: any, totalUsers: any, orgName: any) => {
    const mailUpgradeRequest = `<div>Hello,</div> <br/><div>${orgName} has requested to update their licenses by ${totalUsers}</div> <br/>  <div>Please reach out to them as soon as possible.</div>  <br/>`
    const mailUpgradeRequestFailed = `<div>Hello,</div> <br/><div>${orgName} has requested to update their licenses by ${totalUsers}, but the payment has failed/</div> <br/>  <div>Please reach out to them as soon as possible.</div>  <br/>`
    const mailUpgradeRequestUser = `<div>Hello,</div> <br/><div>Your request to update your Leads Rubix licenses by ${totalUsers} has been forwarded to our team and we will reach out to you as soon as possible.</div> <br/>  <div>Thanks for using Readpro.</div>  <br/>`
    const mailUpgradeRequestUserFailed = `<div>Hello,</div> <br/><div>Your request to update your Leads Rubix licenses by ${totalUsers} could not be fulfilled, we will reach out to you as soon as possible.</div> <br/>  <div>Thanks for using Readpro.</div>  <br/>`
    axios.defaults.headers.common['x-access-token'] =
      authToken
    const res = await axios.post(url + '/payments/createorder', {
      "amount": totalAmount
    });
    let paymentFrom = new Date().toISOString();
    // let paymentTill =  addMonthsWithoutTimestamp(validTill,totalMonths);
    // let formattedPaymentFrom = getFormattedDate(paymentFrom);
    // let formattedPaymentTill = getFormattedDate(paymentTill);
    const { data } = res;
    const options: any = {
      key: "rzp_live_n7jBvjTYwWS5px",
      // key: "rzp_test_PBAMaFcQYsevYS",
      amount: totalAmount,
      currency: "INR",
      name: "Leads Rubix",
      description: "Test Transaction",
      // image: "https://www.itsforyou.live/public/uploads/imp/1624874830.png",
      order_id: data.order.id,
      handler: async (res: any) => {
        axios.defaults.headers.common['x-access-token'] =
          authToken
        const resa = await axios.post(url + '/payments/paymentverification', {
          uid: user.uid,
          contact_no: user.contact_no,
          contact_owner_email: user.user_email,
          organization_id: user.organization_id,
          receipt: data.order.receipt,
          currency: "INR",
          amount: data.order.amount / 100,
          razorpay_order_id: res.razorpay_order_id,
          razorpay_payment_id: res.razorpay_payment_id,
          razorpay_signature: res.razorpay_signature,
          invoice_no: "201906-28",
          company: orgName,
          email: adminMailId,
          phone: contactNumber,
          address: address,
          transaction_date: paymentFrom,
          due_date: paymentFrom,
          paymentFrom: paymentFrom,
          paymentTill: paymentFrom,
          units: units,
          igst: isIGST,
          items: [
            {
              serialNumber: 1,
              description: `${units} license for ${daysDifference} days at Rs ${perDayLicenseCost}/day`,
              qty: 1,
              hsn: 997331,
              rate: totalAmount,
              taxAmount: Number(tax),
            },
          ]
        });
        if (resa.data.success) {
          setOpenModal(true);
          setIsTransactionSuccess(true);
          updatePlan(user.organization_id);
          // sendMail(mailUpgradeRequest,["helpdesk@itsforyou.live","accounts@itsforyou.live"],"Users Upgrade Request");
          // sendMail(mailUpgradeRequestUser,mailId,"Users Upgrade Request");
        } else {
          setOpenModal(true);
          setIsTransactionSuccess(false);
          // sendMail(mailUpgradeRequestUserFailed,mailId,"Users Upgrade Request Failed");
          // sendMail(mailUpgradeRequestFailed,["helpdesk@itsforyou.live","accounts@itsforyou.live"],"Users Upgrade Request");
        }
      },
      prefill: {
        name: orgName,
        email: mailId,
        contact: contactNumber,
      },
      notes: {
        address: address,
      },
      // theme: {
      //   color: "#3399cc",
      // },
    };

    const rzpay = new Razorpay(options);

    rzpay.on("payment.failed", (err: any) => {
      setOpenModal(true);
      setIsTransactionSuccess(false);
      // sendMail(mailUpgradeRequestUserFailed,mailId,"Payment Failed");
      // sendMail(mailUpgradeRequestFailed,["helpdesk@itsforyou.live","accounts@itsforyou.live"],"Payment Failed");
    });

    rzpay.open();
  }, [Razorpay]);

  const history = useHistory();
  const containerStyles = {
    backgroundColor: theme
      ? themeColors.backgroundColor
      : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };
  const cardContainerStyles = {
    backgroundColor: theme
      ? themeColors.cardBackgroundColor
      : themeColors.cardBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };
  const tdStyles = {
    backgroundColor: theme
      ? themeColors.tdBackgroundColor
      : themeColors.tdBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    padding: "1rem",
  };
  const trBorderStyles = {
    borderBottomColor: theme
      ? `1px solid ${themeColors.trBorderColor}`
      : `1px solid ${themeColors.trBorderColorDark}`,
  };
  const thStyles = {
    backgroundColor: theme
      ? themeColors.thBackgroundColor
      : themeColors.thBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    padding: "1rem",
  };
  const selectInputContainerStyles = { width: "140px", marginRight: "5px" };

  useEffect(() => {
    if (isValidTillDatePassed) {
      alert("Your Leads Rubix subscription has expired, Please renew before upgrading users");
      history.push("/");
    }
  }, [])

  const handleAddEmpNumber = () => {
    updatePlan(user.organization_id);
  }

  const handleUnitsChange = (e: any) => {
    const value = parseInt(e.target.value) || 0;

    if (value <= noEmp) {
      setUnitsValidation(false);
      setUnits(value);
    } else {
      setUnitsValidation(true);
    }
  };
  return (
    <div className={styles.parent}
      style={{
        ...containerStyles,
        marginTop: isMobile ? "6%" : "3.5%",
        padding: isMobile ? "12px" : "0",
        minHeight: isMobile ? "100vh" : undefined,
      }}>
      {openModal &&
        (
          <SuccessAndFailureModal
            isSuccess={isTransactionSuccess}
            open={openModal}
            close={() => setOpenModal(false)}
          />)
      }
      <div
        className={styles.container}
        style={{
          maxHeight: isMobile ? "100vh" : `${maxHeight}px`,
          overflowX: "hidden",
          overflowY: "auto",
          marginBottom: isMobile ? "20px" : "20px",
          width: isMobile ? "100%" : undefined,
          padding: isMobile ? "0" : undefined,
        }}>
        <div>
          <h5
            style={{
              fontFamily: "var(--font-family-main)",
              fontSize: "var(--font-size-medium)",
              textAlign: "center",
              marginBottom: isMobile ? "20px" : undefined
            }}
            className="fw-bold"
          >
            Manage your Leads Rubix Subscription
          </h5>
          <div className={styles.unifiedBox}>
            <div
              className={!isMobile ? styles.flexRowContainer : ""}
              style={{
                width: "100%",
                flexDirection: isMobile ? "column" : "row",
                display: "flex",
                gap: isMobile ? "12px" : "0",
              }}
            >
              <div
                className={styles.unifiedSection}
                style={{
                  flex: 1,
                  minHeight: !isMobile ? "220px" : undefined,
                  boxSizing: "border-box",
                  width: isMobile ? "100%" : undefined,
                  padding: isMobile ? "8px" : undefined,
                }}
              >
                <div style={{ width: "100%", overflowX: "auto" }}>
                  <table
                    className="table rounded bg-white"
                    style={{
                      width: "100%",
                      minWidth: 0,
                      fontSize: isMobile ? "13px" : undefined,
                    }}
                  >
                    <thead className="bg-light">
                      <tr>
                        <th style={{ ...thStyles, fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}>Item</th>
                        <th style={{ ...thStyles, fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}>Cost</th>
                        <th style={{ ...thStyles, fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}>Units</th>
                        <th style={{ ...thStyles, fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}>Total Amount</th>
                      </tr>
                    </thead>
                    {organizationData?.trial_period ? <>
                      <tbody>
                        <tr className="border-bottom">
                          <td style={tdStyles}>
                            <p className="fw-bold mb-1">Leads Rubix License</p>
                            {/* <p>{units} license for {daysDifference} days <br></br> At Rs {numberWithCommas(perDayLicenseCost)}/day <br></br>From {currentDate} to {validTill}</p> */}
                          </td>
                          <td style={tdStyles}>
                            <p className="fw-bold mb-1">₹ {numberWithCommas(0)}</p>
                          </td>
                          <td style={tdStyles}>
                            {noEmp <= 0 ? <>
                              <div style={{ ...selectInputContainerStyles }}>
                                <input type="number" className="form-control"
                                  disabled
                                  value={1}
                                  onChange={(e) => handleUnitsChange(e)}
                                />
                                <span style={{ color: "red" }}> {`User limit exhausted for trial period. Please renew to add users.`}</span>
                              </div>
                            </> : <>
                              <div style={{ ...selectInputContainerStyles }}>
                                <input type="number" min="1" className="form-control" defaultValue={units}
                                  onChange={(e) => handleUnitsChange(e)}
                                />
                                {unitsValidation === true ? <>
                                  <span style={{ color: "red" }}> {`Add Units less than ${noEmp}.`}</span>
                                </> : <></>}
                              </div>
                            </>}

                          </td>
                          <td style={tdStyles}>
                            <p className="fw-normal mb-1">₹ {numberWithCommas(0)}</p>
                            <p>(Prorata Amount)</p>
                          </td>
                        </tr>
                      </tbody>
                    </> : <>
                      <tbody>
                        <tr className="border-bottom">
                          <td style={tdStyles}>
                            <p className="fw-bold mb-1">Leads Rubix License</p>
                            <p>{units} license for {daysDifference} days <br></br> At Rs {numberWithCommas(perDayLicenseCost)}/day <br></br>From {currentDate} to {validTill}</p>
                          </td>
                          <td style={tdStyles}>
                            <p className="fw-bold mb-1">₹ {numberWithCommas(costPerLicense)}</p>
                          </td>
                          <td style={tdStyles}>
                            <div style={{ ...selectInputContainerStyles }}>
                              <input type="number" min="1" className="form-control" defaultValue={units} onChange={(e) => { setUnits(e.target.value) }} />
                            </div>
                          </td>
                          <td style={tdStyles}>
                            <p className="fw-normal mb-1">₹ {numberWithCommas(amount)}</p>
                            <p>(Prorata Amount)</p>
                          </td>
                        </tr>
                      </tbody>
                    </>}
                  </table>
                </div>
              </div>
            </div>
          </div>
          {filterData.length > 0 && (
            <>
              <h5
                style={{
                  fontFamily: "var(--font-family-main)",
                  fontSize: isMobile ? "var(--font-size-large)" : "var(--font-size-medium)",
                  marginTop: isMobile ? "12px" : undefined,
                }}
                className="fw"
              >
                Apply Discount Coupon
              </h5>
              <div
                className="bg-light justify-content-end mt-2"
                style={{
                  width: "100%",
                  padding: isMobile ? "8px" : "10px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: isMobile ? "flex-start" : "space-between",
                  flexDirection: isMobile ? "column" : "row",
                  gap: isMobile ? "8px" : "0",
                  fontFamily: "var(--font-family-main)",
                  fontSize: isMobile ? "13px" : "var(--font-size-small)",
                }}
              >
                <div style={{ width: isMobile ? "100%" : "75%" }}>
                  <InputTextValue
                    title={"Coupon"}
                    value={selectedCoupon}
                    onChange={(e) => setSelectedCoupon(e.target.value)}
                  />
                </div>
                <StyledSubmitButton
                  onClick={handleApplyCoupon}
                >
                  Apply
                </StyledSubmitButton>
                {discountAmount > 0 && (
                  <span style={{ marginLeft: "5px", color: "red", fontSize: "22px", cursor: 'pointer' }} onClick={handleClearCoupon}>✖</span>
                )}
              </div>
              {couponMessage && (
                <p style={{ color: "green", marginTop: "8px", fontSize: "14px" }}>
                  {couponMessage}
                </p>
              )}

              {couponError && (
                <p style={{ color: "red", marginTop: "8px", fontSize: "14px" }}>
                  {couponError}
                </p>
              )}
            </>
          )}
          {discountAmount > 0 && (
            <p className="text-success mt-2" style={{
              marginLeft: "10px",
              fontFamily: "var(--font-family-main)",
              fontSize: "var(--font-size-small)"
            }}>
              Coupon applied! Discount: ₹ {discountAmount}
            </p>
          )}
          {organizationData?.trial_period ? <>
            <h6 className="mt-2" style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" }}>Amount to be paid now</h6>
            <h1 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>₹ {numberWithCommas(0)}</h1>
            {/* <h6>₹ {numberWithCommas(amount)} + ₹ {numberWithCommas(tax)}(18% Tax)</h6> */}
            <div className="mt-4">
              <StyledCancelButton
                onClick={() => {
                  history.push("/subscriptionDetails");
                }}>
                Cancel
              </StyledCancelButton>
              <StyledSubmitButton
                disabled={unitsValidation || noEmp <= 0 ? true : false}
                onClick={() => handleAddEmpNumber()}
              >
                Proceed
              </StyledSubmitButton>
            </div>
          </> : <>
            <div style={{ textAlign: "center", marginTop: "32px" }}>
              <h6 className="mt-2" style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" }}>Amount to be paid now</h6>
              <h1 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>₹ {isCouponApplied ? amountTotal : numberWithCommas(totalAmount)}</h1>
              {discountAmount > 0 ? <>
                <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>₹ {numberWithCommas(amount)} + ₹ {numberWithCommas(tax)}(18% Tax) - ₹ {discountAmount} Discount</h6>
              </> : <>
                <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>₹ {numberWithCommas(amount)} + ₹ {numberWithCommas(tax)}(18% Tax)</h6>
              </>}
            </div>
            <div className="mt-4" style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              marginTop: 20,
              width: "100%",
              gap: "0",
            }}
            >
              <div style={{ marginRight: 8 }}>
                <StyledCancelButton onClick={() => {
                  history.push("/subscriptionDetails");
                }}>
                  Cancel
                </StyledCancelButton>
              </div>
              {isCouponApplied ? <>
                <div>
                  <StyledSubmitButton
                    onClick={() => { handlePayment(amountTotal, units, orgName) }}
                  >
                    Proceed
                  </StyledSubmitButton>
                </div>
              </> : <>
                <div>
                  <StyledSubmitButton
                    onClick={() => { handlePayment(totalAmount, units, orgName) }}
                  >
                    Proceed
                  </StyledSubmitButton>
                </div>
              </>}
            </div>
          </>}
        </div>
      </div>
      {/* <div
        className="card px-4 pt-2 w-100 d-flex flex-row justify-content-between position-absolute bottom-0 end-0"
        style={cardContainerStyles}
      >
        <div>
          <h6>accounts@itsforyou.live</h6>
          <p>(For payments and billing questions)</p>
        </div>
        <div>
          <h6>8755964699</h6>
          <p>(Toll Free 24 hours - Monday to Friday)</p>
        </div>
      </div> */}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode,
    user: state.user.data,
    organizationData: state.organization.organizationData,
    authToken: state.user.authToken
  };
};

export default connect(mapStateToProps)(UpgradeUser);
